/** Canada (Health Canada) regulatory submission pathways — the dropdown
 *  options shown when a user picks CA at dossier dispatch time. Mirrors
 *  the US file's shape so the dispatch form can plug it in with a
 *  country-key swap.
 *
 *  FIRST DRAFT — labels pending regulatory review. These reflect the
 *  standard Health Canada filing classifications as of 2026 but have not
 *  yet been reviewed by a qualified Canadian regulatory consultant.
 *  Do not rely on these labels as authoritative regulatory guidance.
 *
 *  ## Devices — Medical Device Licences (MDL)
 *
 *  Health Canada uses a four-class risk-based scheme under the Medical
 *  Devices Regulations (SOR/98-282). Class I is the lowest risk (self-
 *  declared via registration only). Classes II–IV require an MDL issued
 *  by Health Canada; higher classes require more extensive safety/
 *  effectiveness data.
 *
 *  IVDs use the SAME four-class MDL scheme (classified by the SOR/98-282
 *  Schedule 1 Part 2 rules) — so there is no separate IVD class option here.
 *  The IVD vs non-IVD choice instead selects the IMDRF ToC (N13 vs N9) via the
 *  dossier-format toggle at dispatch (see `dispatch/ca.tsx`).
 */

import type { Product } from '@/features/product/types';
import type { SubmissionGroup } from './us-submission-pathways';

export const CA_SUBMISSION_PATHWAYS: SubmissionGroup[] = [
  {
    productType: 'device',
    label: 'Medical Device / IVD — Health Canada (SOR/98-282)',
    options: [
      { value: 'ca-class-ii',  label: 'Class II — MDL (attestation of safety/effectiveness)' },
      { value: 'ca-class-iii', label: 'Class III — MDL (summary of studies + bibliography)' },
      { value: 'ca-class-iv',  label: 'Class IV — MDL (full pre-clinical + clinical data)' },
    ],
  },
];

/** Pre-fill the picker with the most-common pathway per product type. */
export const CA_DEFAULT_BY_TYPE: Record<Product['product_type'], string> = {
  device:      'ca-class-ii',
  drug:        'ca-class-ii',
  biologic:    'ca-class-ii',
  combination: 'ca-class-ii',
};
